var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#FF6565"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.769 135.004C56.2656 132.948 57.7476 130.553 59.0727 127.161L69.4221 85.5249L84.6682 110.243C82.2232 119.154 76.685 137.529 74.0919 139.746C70.5848 146.79 56.4677 140.678 53.769 135.004Z",
    fill: "#0A893D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4881 143.637C74.981 150.681 62.4306 143.483 61.1517 141.384C69.3654 134.619 75.9217 106.416 76.4432 96.8112L75.1399 91.1299L89.0644 114.134C86.6194 123.045 81.0813 141.42 78.4881 143.637Z",
    fill: "#005537"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.574 89.6821C62.8303 86.1086 63.9835 78.8667 63.3286 76.2139L69.422 85.5249C68.5346 91.0252 67.5569 96.8006 66.2186 103.677C64.8803 110.554 62.0862 121.525 59.4701 127.069C56.8541 132.612 54.0173 135.34 54.0173 135.34C54.0173 135.34 52.0811 132.877 51.5258 131.781C53.1631 129.574 54.5157 125.445 55.8682 121.317C57.5136 116.294 62.2632 94.0156 62.574 89.6821Z",
    fill: "#F5F3EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4229 32.6537C36.628 29.7949 39.9538 24.6668 43.2426 23.0009C50.2852 21.041 65.589 18.9833 69.3248 18.7442C73.0606 18.505 77.8386 17.8759 81.711 22.8018C99.436 49.6388 129.092 98.6714 129.647 99.7677C130.202 100.864 129.675 105.263 129.134 106.915C128.322 109.392 105.544 114.731 99.7776 115.585C94.9726 116.297 88.2314 114.546 86.2952 112.083L55.8279 65.5271C49.5494 55.8507 36.2179 35.5125 36.4229 32.6537Z",
    fill: "#F0EEE7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0824 109.791L41.2897 24.7906C40.4455 24.5857 34.3787 31.1604 36.9366 35.358L82.9491 107.331L93.0824 109.791Z",
    fill: "#E0DED6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.143 27.6464C53.3727 28.4768 51.4314 28.8121 49.7347 29.4408C49.0161 29.707 48.756 30.5494 49.147 31.2085C62.1512 53.1256 86.808 92.9076 90.5549 98.9472C90.8539 99.4291 91.409 99.6363 91.9608 99.5051C95.8849 98.5723 111.41 94.8649 120.988 92.3297C121.846 92.1026 122.234 91.12 121.76 90.37C107.953 68.5375 83.2397 31.1004 82.7261 30.0683C82.2005 29.0122 80.884 27.6908 78.5114 26.895C75.3479 25.8339 62.6079 26.4427 57.143 27.6464Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2238 106.518L82.4219 107.156C83.3473 108.983 84.509 111.442 86.8496 113.179C89.0563 114.816 91.2655 115.82 95.9328 116.154C99.5063 116.411 108.291 114.716 114.327 113.036C120.364 111.356 127.496 109.121 128.863 107.74C130.23 106.359 130.201 100.864 129.646 99.7676C128.411 101.731 126.548 103.22 124.36 103.992L119.88 105.572C116.165 106.882 112.349 107.882 108.469 108.562L102.185 109.662C100.585 109.943 98.9408 109.825 97.3971 109.319L89.4462 106.714C88.0825 106.268 86.623 106.2 85.2238 106.518Z",
    fill: "#00A142"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.4913 115.908C92.4913 115.908 91.393 109.382 96.025 108.719C91.3686 105.8 82.1046 107.127 82.1046 107.127C82.1046 107.127 83.6089 110.182 84.6623 111.325C86.7855 113.629 90.5894 115.148 92.4913 115.908Z",
    fill: "#005537"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1652 31.9366C57.5646 32.7673 56.1606 32.9719 54.5756 33.8145C65.8015 52.7663 90.9839 93.7206 91.4732 93.8939C91.9624 94.0672 110.057 89.7274 118.111 87.4322C107.135 69.9728 82.2594 32.343 81.7701 32.1697L78.7122 31.0866C76.266 30.2201 65.3076 30.981 61.1652 31.9366Z",
    fill: "#72706C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7592 37.898C83.39 34.3808 81.8879 32.2114 81.7713 32.1701L78.7134 31.087C76.2671 30.2205 65.3087 30.9814 61.1664 31.937C60.5057 32.0894 59.9189 32.2208 59.3914 32.3389C57.0444 32.8642 55.8709 33.1269 54.5767 33.8149C65.8027 52.7667 90.9851 93.721 91.4743 93.8943C91.5067 93.9057 91.6159 93.8975 91.794 93.8714L85.7592 37.898Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.247 46.5522L47.3774 103.014L60.4005 114.773L111.807 58.7613L101.247 46.5522Z",
    fill: "#FF3300"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1155 98.7299C74.1088 99.7794 72.9735 96.3094 72.9735 95.7954C72.9281 94.1829 72.7418 92.5775 72.4166 90.9974C71.8567 89.4319 71.0779 87.9535 70.1033 86.6064C69.3322 85.4498 66.8904 82.5581 68.197 81.1445L94.0931 54.0488C94.0931 54.0488 95.0356 56.3407 95.0999 56.5977C96.3208 63.1949 87.0461 72.6838 94.9285 77.2247L75.1155 98.7299Z",
    fill: "url(#paint0_linear_964_6163)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1631 60.3035L57.573 46.3594L112 101.515L103.196 114.966L47.1631 60.3035Z",
    fill: "#FF3300"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.848 68.9144L84.4746 63.3882C84.4746 63.3882 85.3314 66.3869 86.6166 69.3856C88.3944 73.798 91.1361 78.6174 93.0424 79.517L97.6262 86.7782L79.848 68.9144Z",
    fill: "#723034"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_964_6163",
    x1: 88.692,
    y1: 38.2413,
    x2: 66.0699,
    y2: 86.2562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF4941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A1717"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.90ba9875e35aecfb659b94304f61ace9.svg";
export { ForwardRef as ReactComponent };